import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { key } from '../../messages';

export default class BrowserUnsupported extends React.PureComponent<any, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		return (
			<div className="container">
				<h1 className="text-danger">
					<FormattedMessage
						id={key((o) => o.containers.browserUnsupported.header)}
					/>
				</h1>
				<section>
					<p>
						<FormattedMessage
							id={key((o) => o.containers.browserUnsupported.message)}
						/>
					</p>
					<h2>
						<FormattedMessage
							id={key((o) => o.containers.browserUnsupported.resolveHeader)}
						/>
					</h2>
					<ul>
						<li>
							<a
								href="https://www.mozilla.com/firefox/"
								target="_blank"
								rel="noreferrer"
							>
								Firefox
							</a>
						</li>
						<li>
							<a
								href="https://www.google.com/chrome/browser/desktop/"
								target="_blank"
								rel="noreferrer"
							>
								Chrome
							</a>
						</li>
						<li>
							<a
								href="https://www.microsoft.com/en-us/windows/microsoft-edge"
								target="_blank"
								rel="noreferrer"
							>
								Microsoft Edge
							</a>
						</li>
						<li>
							<a
								href="https://windows.microsoft.com/en-us/internet-explorer/download-ie"
								target="_blank"
								rel="noreferrer"
							>
								Internet Explorer
							</a>
						</li>
					</ul>
				</section>
				<section>
					<h3>
						<FormattedMessage
							id={key((o) => o.containers.browserUnsupported.helpHeader)}
						/>
					</h3>
					<ul>
						<li>
							<FormattedMessage
								id={key(
									(o) => o.containers.browserUnsupported.helpListItemZero
								)}
							/>
						</li>
						<li>
							<FormattedMessage
								id={key((o) => o.containers.browserUnsupported.helpListItemOne)}
							/>
						</li>
					</ul>
				</section>
			</div>
		);
	}
}
